'use client';

import React from 'react';


const HeroSection = () => {
  const handleGuideDownload = () => {
    // Extract file ID from Google Drive URL
    const fileId = '14ZoahN14HMSCHgwPjvKucshNWTXbUXcC';
    
    // Create direct download link
    const downloadUrl = `https://drive.google.com/uc?export=download&id=${fileId}`;
    
    // Open in new window to trigger download
    const downloadWindow = window.open(downloadUrl, '_blank');
    
    // Fallback: If popup blocked, use direct navigation
    if (!downloadWindow) {
      window.location.href = downloadUrl;
    }
  };

  return (
    <section className="relative min-h-[500px] bg-gradient-to-br from-primary-700 to-primary-900 text-white overflow-hidden">
      {/* Decorative Background Pattern */}
      <div className="absolute inset-0 opacity-10">
        <div className="absolute inset-0" style={{ backgroundImage: 'repeating-linear-gradient(45deg, transparent, transparent 35px, rgba(255,255,255,.1) 35px, rgba(255,255,255,.1) 70px)' }}></div>
      </div>

      <div className="container mx-auto px-4 py-16 relative z-10">
        <div className="max-w-4xl mx-auto text-center space-y-8">
          {/* Badge */}
          <div className="inline-flex items-center gap-2 bg-white/20 backdrop-blur-sm px-6 py-3 rounded-full">
            <span className="text-2xl">📚</span>
            <span className="font-semibold">Guide Complet 2025</span>
          </div>

          {/* Main Heading */}
          <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold leading-tight">
            Votre Guide Ultime pour
            <span className="block text-yellow-300 mt-2">S'installer au Maroc</span>
          </h1>

          {/* Description */}
          <p className="text-xl text-white/90 max-w-2xl mx-auto leading-relaxed">
            Tout ce que vous devez savoir sur la vie, les démarches administratives, la culture et les opportunités au Maroc. Mis à jour régulièrement avec les dernières informations.
          </p>

          {/* CTA Buttons */}
          <div className="flex flex-col sm:flex-row gap-4 justify-center items-center pt-4">
            <button
              onClick={handleGuideDownload}
              className="bg-yellow-400 text-primary-900 px-10 py-5 rounded-lg font-bold hover:bg-yellow-300 transition-all transform hover:scale-105 shadow-2xl inline-flex items-center gap-3 text-lg"
            >
              <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 10v6m0 0l-3-3m3 3l3-3m2 8H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
              </svg>
              Télécharger le Guide PDF
              <span className="text-sm font-normal">(Gratuit)</span>
            </button>
            <button className="border-2 border-white/50 text-white px-8 py-4 rounded-lg font-semibold hover:bg-white/10 transition-all backdrop-blur-sm">
              Parcourir les Sections
            </button>
          </div>

          {/* Quick Stats */}
          <div className="grid grid-cols-2 md:grid-cols-4 gap-6 pt-12 max-w-3xl mx-auto">
            <div className="text-center">
              <div className="text-3xl font-bold text-yellow-300">12</div>
              <div className="text-white/80">Villes Couvertes</div>
            </div>
            <div className="text-center">
              <div className="text-3xl font-bold text-yellow-300">50+</div>
              <div className="text-white/80">Guides Pratiques</div>
            </div>
            <div className="text-center">
              <div className="text-3xl font-bold text-yellow-300">100k+</div>
              <div className="text-white/80">Téléchargements</div>
            </div>
            <div className="text-center">
              <div className="text-3xl font-bold text-yellow-300">2025</div>
              <div className="text-white/80">Mise à jour</div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default HeroSection;